module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"none":"Оповещений нет","notif":{"certsTransfer":"Запрос на передачу сертификатов"},"modal":{"certsTransfer":{"message":"Вы станете новым владельцем этих сертификатов после подтверждения.\\n","title":"Передача сертификатов {range} от {sender.fullName}","ok":"Принять","cancel":"Отмена"}}}}')
  delete Component.options._Ctor
}
